/**
 * @eab-pip/pi-io captures all centralized IO rules
 */
import { IO } from './core/io';

export * from './core/interceptor';
export * from './core/adapter';
export * from './core/io';

export type { RequestAPI, ResponseAPI, OptionsAPI } from './adapters/api';
export type { RequestStorage, ResponseStorage } from './adapters/storage';
export type { RequestMemory, ResponseMemory } from './adapters/memory';
export type { RequestCookie, ResponseCookie } from './adapters/cookie';
export type { RequestNull, ResponseNull } from './adapters/null';

export default new IO();
